import type { RouteRecordRaw } from 'vue-router';

import RouteName from '@/router/RouteName';

const AuthenticationPage = async () => import('@/pages/AuthenticationPage.vue');

export default function getAuthenticationRoutes(): RouteRecordRaw[] {
  return [
    {
      name: RouteName.AUTHENTICATION,
      component: AuthenticationPage,
      meta: {
        title: 'Login',
      },
      path: '/login',
    },
  ];
}
